import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';

import Button from '@dojo/widgets/button';
import Radio from '@dojo/widgets/radio';
import Label from '@dojo/widgets/label';
import { formatAriaProperties } from '@dojo/widgets/common/util';

import Correct from '../widgets/correct';
import NumericEntryBase from './ne-base';

import css from '../css/numeric-entry.m.css';

@theme(css)
export class NEQuestionAudit extends NumericEntryBase {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	protected onChange(value: string): void {
		//
	}

	protected update_result(): Promise<void> {
		return Promise.resolve();
	}

	protected submitted(): void {
		this.invalidate();
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	protected nls_text() {
		const {
			localizedBundle: {
				messages: {
					previous_question: previousText = '',
					next_question: nextText = '',
					review: reviewText = '',
					loading: loadingText = '',
					correct: correctText = '',
					incorrect: incorrectText = '',
					rationale: rationaleText = '',
					for_more_information: fmiText = '' //,
					//					distractor_legend: distractorLegend = ''
				}
			}
		} = this.properties;

		return {
			previousText,
			nextText,
			reviewText,
			loadingText,
			correctText,
			incorrectText,
			rationaleText,
			fmiText //,
			//			distractorLegend
		};
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	protected render_buttons(which: { islast?: boolean; isfeedback?: boolean }): DNode[] {
		const { previousText, nextText, reviewText, loadingText } = this.nls_text();
		const {
			onNextQuestion,
			onPreviousQuestion = () => undefined,
			hasNextQuestion = () => false,
			hasPreviousQuestion = () => false,
			onReview,
			loaded
		} = this.properties;

		const buttons = [
			v('div', { classes: [this.theme(css.oneaction)] }, [
				w(
					Button,
					{
						key: 'previous',
						disabled: !hasPreviousQuestion(),
						onClick: () => {
							onPreviousQuestion();
						}
					},
					[previousText]
				)
			]),
			v('div', { classes: [this.theme(css.oneaction)] }, [
				w(
					Button,
					{
						key: 'next',
						disabled: !hasNextQuestion(),
						onClick: () => {
							onNextQuestion();
						}
					},
					[nextText]
				)
			]),
			v('div', { classes: [this.theme(css.oneaction)] }, [
				w(
					Button,
					{
						key: 'review',
						disabled: !loaded,
						onClick: () => {
							onReview(true);
						}
					},
					[loaded ? reviewText : loadingText]
				)
			])
		];

		return buttons;
	}

	protected get_numberofquestions(): number {
		const { quizstore } = this.properties;
		const { get, path } = quizstore;
		const info = get(path('info'));
		return info.lastresult.numberofquestions;
	}

	/*	protected render_feedback(): DNode {
		const { correctText, incorrectText, rationaleText, fmiText, distractorLegend } = this.nls_text();
		const { question } = this.properties;
		const { distractororder, distractordata, flags, text, feedback, refname, id, questiontype } = question;
		const numberofquestions = this.get_numberofquestions();
		const islast = question.cursor + 1 === numberofquestions;

		const modifiedText = this.modifyQuestion(text);

		const distractors: DNode[] = distractororder.map((which, idx) => {
			const { text, chosen } = distractordata[which];
			const iscorrect = flags[idx + 4];
			const hasflag = iscorrect || (chosen && !iscorrect);
			const widgetId = `d-${which}`;
			return v('div', { key: `${which}`, classes: [this.theme(css.distractor)] }, [
				v('div', { key: 'hint', classes: [this.theme(css.distractorHint)] }),
				w(Radio, {
					widgetId,
					disabled: true,
					name: `mc-distractor`,
					value: `${which}`,
					checked: chosen,
					onValue: () => {
						//
					}
				}),
				w(Label, { forId: widgetId }, [
					iscorrect ? w(Correct, { key: which, iscorrect, title: correctText }) : null,
					chosen && !iscorrect ? w(Correct, { key: which, iscorrect, title: incorrectText }) : null,
					v('div', {
						classes: [this.theme(css.distractorLabel), hasflag ? this.theme(css.distractorWithFlag) : null],
						innerHTML: text
					})
				])
			]);
		});

		return v('div', { key: id, xqa: `${questiontype} ${id}`, classes: [this.theme(css.root)] }, [
			v('div', { key: 'feedback-block', classes: [this.theme(css.feedback)] }, [
				v('h2', { key: 'rationale', classes: [this.theme(css.rationale)] }, [rationaleText]),
				v('div', { innerHTML: feedback }),
				v('p', { classes: [this.theme(css.fmi)] }, [`${fmiText} ${refname}`])
			]),
			v('div', { key: 'question-text', classes: [this.theme(css.question)], innerHTML: modifiedText }),
			v('fieldset', { key: 'distractors-fieldset', classes: [this.theme(css.distractorFieldset)] }, [
				v('legend', { classes: [this.theme(css.distractorLegend)] }, [distractorLegend]),
				v(
					'div',
					{
						key: 'distractors',
						role: 'group',
						...formatAriaProperties({ labelledby: 'question-label' }),
						classes: [this.theme(css.distractorBlock)]
					},
					distractors
				)
			]),
			v('div', { key: 'action-block', xqa: 'action block', classes: [this.theme(css.actions)] }, [
				v(
					'div',
					{ key: 'submit-action', xqa: 'action submit', classes: [this.theme(css.oneaction)] },
					this.render_buttons({ islast, isfeedback: true })
				)
			])
		]);
	}
*/
	protected render(): DNode {
		return this.render_feedback();
	}
}

export default NEQuestionAudit;
